import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  ref?: React.Ref<HTMLInputElement>;
  /** sm: filter bars and table cells. Phones get a 44px control either way. */
  controlSize?: 'md' | 'sm';
  /** As wide as it naturally is, rather than the full width of its container. */
  inline?: boolean;
  /** No box of its own, for a wrapper that draws the box and holds an icon. */
  bare?: boolean;
}

const Input: React.FC<InputProps> = ({ className, controlSize = 'md', inline = false, bare = false, ...rest }) => (
  <input
    {...rest}
    className={[
      'ui-input',
      controlSize === 'sm' ? 'ui-input--sm' : '',
      inline ? 'ui-input--inline' : '',
      bare ? 'ui-input--bare' : '',
      className || '',
    ]
      .filter(Boolean)
      .join(' ')}
  />
);

export default Input;
